export const createScheduledAppointmentsSlice = (set, get) => ({
  scheduledAppointments: [],

  // Add or update an appointment (appointmentKey is used for matching, not stored)
  setAppointmentForService: (appointmentKey, appointmentData) => {
    set((state) => {
      // Find existing appointment by matching serviceIds array
      const existingIndex = state.scheduledAppointments.findIndex((appt) => {
        if (!appt.serviceIds || !Array.isArray(appt.serviceIds)) return false;
        const apptKey = [...appt.serviceIds].sort().join('-');
        return apptKey === appointmentKey;
      });

      if (existingIndex >= 0) {
        // Update existing appointment (don't add appointmentKey to the data)
        const updated = [...state.scheduledAppointments];
        updated[existingIndex] = { ...appointmentData };
        return { scheduledAppointments: updated };
      } else {
        // Add new appointment (don't add appointmentKey to the data)
        return {
          scheduledAppointments: [...state.scheduledAppointments, { ...appointmentData }]
        };
      }
    });
  },

  // Remove an appointment by key
  removeAppointmentForService: (appointmentKey) => {
    set((state) => ({
      scheduledAppointments: state.scheduledAppointments.filter((appt) => {
        if (!appt.serviceIds || !Array.isArray(appt.serviceIds)) {
          // Also remove old format appointments
          return appt.serviceId !== appointmentKey;
        }
        const apptKey = [...appt.serviceIds].sort().join('-');
        return apptKey !== appointmentKey;
      })
    }));
  },

  // Get appointment by key
  getAppointmentForService: (appointmentKey) => {
    const appointments = get().scheduledAppointments;
    return appointments.find((appt) => {
      if (!appt.serviceIds || !Array.isArray(appt.serviceIds)) return false;
      const apptKey = [...appt.serviceIds].sort().join('-');
      return apptKey === appointmentKey;
    });
  },

  // Clear all appointments
  clearAllAppointments: () => {
    set({ scheduledAppointments: [] });
  },

  // Check if all required services have appointments
  allServicesHaveAppointments: (serviceIds) => {
    const appointments = get().scheduledAppointments;
    const scheduledServiceIds = new Set();

    // Flatten all serviceIds from all appointments
    appointments.forEach(appt => {
      if (appt.serviceIds && Array.isArray(appt.serviceIds)) {
        appt.serviceIds.forEach(id => scheduledServiceIds.add(String(id)));
      }
    });

    // Check if all required services are scheduled
    return serviceIds.every((serviceId) => scheduledServiceIds.has(String(serviceId)));
  }
});
